// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"SubscriptionBasket_Wrapper__J6skL","Container":"SubscriptionBasket_Container__Brx6Q","Text":"SubscriptionBasket_Text__j2SOw"};